// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VtrxF","image":"styles_image__OlPQl","header":"styles_header__50xbE","description":"styles_description__Ybx-W"};